module.exports = __webpack_public_path__ + "static/media/swim-pony.11a52da1.md";